// Everything past sign-in. When a console route answers `second-factor-required` (spec/07 §6.6), the
// step-up screen covers the page until the session has proved a second factor; then the page comes
// back and reads again. The page stays mounted underneath — hidden and inert — so an editor's unsaved
// changes are still there when they return.

import { Outlet } from '@tanstack/react-router';

import { useSecondFactorGate } from '../auth/second-factor-gate';
import { StepUp } from '../auth/StepUp';
import { PlaceSwitchProvider } from './place-switch';

export function SignedIn() {
  const gate = useSecondFactorGate();
  return (
    <PlaceSwitchProvider>
      <div hidden={gate.required} inert={gate.required}>
        <Outlet />
      </div>
      {gate.required ? <StepUp /> : null}
    </PlaceSwitchProvider>
  );
}
